/* eslint-disable max-classes-per-file */
import { Location, MemoryHistory } from 'history';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { MatchedRoute } from 'react-router-config';
import { Store } from 'redux';
import { MatchProps } from './components/EpisodeEditorPublish/types';

type WithTitleProps = {
  title?: string;
  BaseComponent: React.ComponentType & {
    fetchData?: (data: FetchDataProps) => void;
  };
};

type FetchDataProps = {
  history: MemoryHistory;
  match: MatchProps;
  location: Location;
  store: Store<any>;
  baseUrl: string;
  route: MatchedRoute<{
    [x: string]: string;
  }>;
};

export const TITLE_SUFFIXES = {
  DEFAULT: `Anchor - The easiest way to make a podcast`,
  PROFILE_PAGE: ` • A podcast on Anchor`,
};

export const Title = ({
  title = TITLE_SUFFIXES.DEFAULT,
}: Pick<WithTitleProps, 'title'>) => {
  return (
    <Helmet>
      {title && (
        <>
          <title>{title}</title>
          <meta property="og:title" content={title} />
          <meta name="twitter:title" content={title} />
        </>
      )}
    </Helmet>
  );
};

export const WithTitle = ({
  title = TITLE_SUFFIXES.DEFAULT,
  BaseComponent,
}: WithTitleProps) => {
  const WithTitleComponent = (props: any) => {
    return (
      <>
        <Title title={title} />
        <BaseComponent {...props} />
      </>
    );
  };

  if (BaseComponent.fetchData) {
    WithTitleComponent.fetchData = BaseComponent.fetchData;
  }

  return WithTitleComponent;
};
